import { z } from "zod";

export const patchIncomingInvoiceReminderParamsSchema = z.object({
	reminderId: z.string().min(1),
});

export type PatchIncomingInvoiceReminderParamsSchema = z.infer<
	typeof patchIncomingInvoiceReminderParamsSchema
>;
